import { render, staticRenderFns } from "./RecruitDetail.vue?vue&type=template&id=61eac4bc&scoped=true&"
import script from "./RecruitDetail.vue?vue&type=script&lang=js&"
export * from "./RecruitDetail.vue?vue&type=script&lang=js&"
import style0 from "./RecruitDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./RecruitDetail.vue?vue&type=style&index=1&id=61eac4bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eac4bc",
  null
  
)

export default component.exports